import { useState, useEffect, useRef } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const REVENUE_SPEND_PAGE_SORT_FIELDS = ['id', 'accountId', 'account.extra.keitaroLogin', 'agencyId', 'at', 'amount'] as const

export type IRevenueSpendSortField = typeof REVENUE_SPEND_PAGE_SORT_FIELDS[number]

type IUseSortRevenueSpendPage = {
	sortBy: IRevenueSpendSortField;
	setSortBy: (value: (((prevState: IRevenueSpendSortField) => IRevenueSpendSortField) | IRevenueSpendSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IRevenueSpendSortField = 'id'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useRevenueSpendSortPage = (buyer: number): IUseSortRevenueSpendPage => {
	const isFirstRender = useRef<boolean>(true)
	const [buyerPrev, setBuyerPrev] = useState<number>(buyer)
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return REVENUE_SPEND_PAGE_SORT_FIELDS.includes(item[0] as IRevenueSpendSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IRevenueSpendSortField>(urlSort?.[0]?.[0] as IRevenueSpendSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)

	useEffect(() => {
		let _sortBy = sortBy
		let _order = order
		// reset sort logic [RSL] onBuyer (menu tabs) changed
		if (!isFirstRender.current && buyerPrev !== buyer) {
			setBuyerPrev(buyer)
			_sortBy = DEFAULT_SORT_BY
			_order = DEFAULT_SORT_ORDER
			setSortBy(DEFAULT_SORT_BY)
			setOrder(DEFAULT_SORT_ORDER)
		}

		if (_sortBy && _order) {
			const newSortStr = lib.sortSetup([[_sortBy, _order]])

			setSearchParams((prev) => {
				if (!isFirstRender.current) {
					if (_order !== ESortOrder.unset) {
						prev.set('s', newSortStr)
					} else {
						prev.delete('s')
					}
				} else {
					isFirstRender.current = false
				}

				return prev
			})
		}
	}, [buyer, sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}